import React from 'react';
import agent from '../../../../agent';
import TextWidget from '../TextWidget/TextWidget';
import LoaderWidget from '../Loader/LoaderWidget';
import ImageWidget from '../ImageWidget/ImageWidget'
import {checkForUnauthorisedResponse} from '../../../Utils/ErrorHandler'

class SavedSearchColumnValueWidgetContainer extends React.Component {

  constructor() {
    super();
    this.state = {
      search: {
        value:""
      },
      loaded:false
    };
  }

  componentDidMount() {
    this.refresh()
  }

  refresh() {
    this.runSearch(this.props.savedSearchId, this.props.bypassCache, this.props.columnToDisplay, this.props.resultIsImage);
  }

  runSearch(savedSearchId, bypassCache, columnValue, resultIsImage) {

    agent.Search.executeColumnSearch(savedSearchId, bypassCache, columnValue, resultIsImage).then(
      res => {
        if(res.result) {
          this.setState({
            ...this.state,
            'search':res.data,
            loaded:true
          })
        } else {
          this.setState({
            ...this.state,
            loaded:true
          })
        }
      },
      error => {
        if(!checkForUnauthorisedResponse(error, agent)) {
          this.setState({
            ...this.state,
            'loaded':true
          })
        }
      }
    )

  }

  render() {
    if(this.state.loaded && !this.props.resultIsImage) {
      return (
        <TextWidget {...this.props} onWidgetRefresh={this.refresh.bind(this)} value={this.state.search.value}/>
      )
    } else if(this.state.loaded && this.props.resultIsImage) {
      return (
        <ImageWidget {...this.props} onWidgetRefresh={this.refresh.bind(this)} imageUrl={this.state.search.value} name={this.props.title}/>
      )
    } else {
      return (<LoaderWidget {...this.props}/>)
    }
  }
}

export default SavedSearchColumnValueWidgetContainer;



// WEBPACK FOOTER //
// ./src/components/Dashboard/components/SavedSearchColumnValueWidget/SavedSearchColumnValueWidgetContainer.js